import { formatUrl } from '@lexical/link';

import { sanitizeUrl as coreSanitizeUrl } from '../../../format';

/**
 * Санитизация URL для Lexical: сначала форматирует через formatUrl
 * (добавляет http:// если нет схемы)
 */
export const sanitizeUrl = (url: string): string => {
  return coreSanitizeUrl(formatUrl(url));
};
